// extracted by mini-css-extract-plugin
export default {"wrap":"MyProfilePage_wrap__XIYFA","backBtn":"MyProfilePage_backBtn__4iTYx"};